import { defaultLocale } from '../lang/allLocales'

export const getLocalePrefix = (locale?: string | null) => {
  if (!locale || locale === defaultLocale) return ''
  return locale
}
